module.exports = __webpack_public_path__ + "img/no-logo.82576687.png";